import {Utils} from '../Utils';

export class PostUtil
{
	static handleResponse(resp, showError = null, skipUnknown = false)
	{
		if(resp.status > 199 && resp.status < 300)
		{
			return true;
		}

		if(showError)
		{
			if(resp.status === 410)
			{
				showError({elm: (
					<div>
						<p><span>{Utils.tr('ERROR_EXPIRE')}</span>
						<a onClick={() => {window.location.reload()}}>{Utils.tr('ERROR_EXPIRE_2')}</a>
						<span>{Utils.tr('ERROR_EXPIRE_3')}</span></p>
					</div>)
				, clazz: 'is-danger'
				});
			}
			else if(resp.status === 429)
			{
				showError({elm: (
					<div>
						<p><span>{Utils.tr('ERROR_RATELIMIT')}</span></p>
					</div>)
				, clazz: 'is-danger'
				});
			}
			else if(resp.status === 400)
			{
				if(resp.headers.get('Content-Type') === 'application/json')
				{
					resp.json().then((json) =>
					{
						let err = json.hasOwnProperty('error') ? json['error'] : 'ERROR_UNKNOWN';
						let msg = Utils.tr(err);
						if(msg)
						{
							if(json.hasOwnProperty('field') && msg.indexOf('%VALUE%') !== -1)
							{
								const field = json['field'];
								msg = msg.replace('%VALUE%', field.toUpperCase());
							}
							showError({elm: (
								<div>
									<p><span>{msg}</span></p>
								</div>)
							, clazz: 'is-danger'
							});
						}
					});
				}
			}
			else if(!skipUnknown)
			{
				showError({elm: (
					<div>
						<p><span>{Utils.tr('ERROR_UNKNOWN')}</span></p>
					</div>)
				, clazz: 'is-danger'
				});	
			}
		}

		return false;
	}

	static makeRequest(uri, data = null, sep = ',')
	{
		const gateway = process.env.REACT_APP_GATEWAY ? process.env.REACT_APP_GATEWAY : '';
		let params = {'credentials': 'include'};
		if(data)
		{
			const headers = {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
			let body = [];
			let f;
			for (f in data)
			{
				body.push(encodeURIComponent(f) + '=' + encodeURIComponent(Array.isArray(data[f]) ? data[f].join(sep) : data[f]));
			}
			params['method'] = 'POST';
			params['headers'] = headers;
			params['body'] = body.join('&');
		}

		document.body.classList.add('is-loading');
		return fetch(gateway + uri, params).finally(() =>
		{
			document.body.classList.remove('is-loading');
		});
	};
} 